import { StylePanelProps } from '@/lib/stylePanel'
import useResponsivePadding from '@/lib/useResponsivePadding'

import styles from './Gallarytext.module.css'

export type GallarytextProps = {
  title: string
  subtitle?: string
  content: React.ReactNode
  button?: React.ReactNode
  asset_one?: {
    url: string
    altText?: string
  }
  asset_two?: {
    url: string
    altText?: string
  }
  asset_three?: {
    url: string
    altText?: string
  }
  reverse?: boolean
  mobileReverse?: boolean
} & StylePanelProps

export const PhnxGallarytext: React.FC<GallarytextProps> = ({
  title,
  subtitle,
  content,
  button,
  asset_one,
  asset_two,
  asset_three,
  reverse = true,
  mobileReverse,
  padding,
  backgroundColor,
  textColor,
}) => {
  const paddingStyles = useResponsivePadding(padding)

  const style = {
    ...paddingStyles,
    backgroundColor,
    color: textColor,
  }

  return (
    <div style={style} className="stylepanel">
      <style jsx>{`
        stylepanel {
          ${paddingStyles}
        }
      `}</style>
      <div
        className={`${styles['gallarytext']} ${reverse ? styles['reverse'] : ''} ${mobileReverse ? styles['mobile-reverse'] : ''} container grid-tw-container`}
        data-testid="gallarytext"
        data-test-reverse={reverse}
        data-test-mobile-reverse={mobileReverse}
      >
        <div className={styles['asset-holder']} data-testid="asset-holder">
          <div className={styles['grid-container']}>
            <div className={styles['group-a']}>
              {asset_one && asset_one.url && (
                <div className={styles['image-one']}>
                  <img
                    src={asset_one.url}
                    alt={asset_one.altText ? asset_one.altText : 'feature one'}
                  />
                </div>
              )}
              {asset_two && asset_two.url && (
                <div className={styles['image-two']}>
                  <img
                    src={asset_two.url}
                    alt={asset_two.altText ? asset_two.altText : 'feature two'}
                  />
                </div>
              )}
            </div>

            <div className={styles['group-b']}>
              {asset_three && asset_three.url && (
                <div className={styles['image-three']}>
                  <img
                    src={asset_three.url}
                    alt={asset_three.altText ? asset_three.altText : 'feature three'}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <div className={`title-container-group ${styles['text-holder']}`}>
          {title && (
            <div className="title" data-testid="title">
              {title}
            </div>
          )}

          {subtitle && (
            <div className={`subtitle`} data-testid="subtitle">
              <p
                dangerouslySetInnerHTML={{
                  __html: subtitle,
                }}
              ></p>
            </div>
          )}
          {content && <div className={styles['content']}>{content}</div>}
          {button && (
            <div className={styles['button-holder']} data-testid="button">
              {button}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
